import { observer } from 'mobx-react-lite';
import * as React from 'react';

const styles = require('./SpamOptionFull.scss');

export interface SpamOptionIconBarProps {
    iconButtons: JSX.Element[];
}

const SpamOptionIconBar = observer(function SpamOptionIconBar(props: SpamOptionIconBarProps) {
    return <div className={styles.iconBar}>{props.iconButtons}</div>;
});
export default SpamOptionIconBar;
